import { takeLatest, call, put, select } from "redux-saga/effects";
import {
  GET_AZURE_ACTIVITY_LOGS,
  GET_AZURE_ACTIVITY_LOGS_SUCCESS,
  GET_AZURE_ACTIVITY_LOGS_ERROR,
} from "./constant";

import { getAzureActivityLogsApi } from "./api";

/**
 * action Type of GET_DASHBOARD_INFO
 * @param {Object} action
 */
function* getAzureActivityLogsList(params) {
  try {
    const provider = yield select(state => state.CloudProviderStore ? state.CloudProviderStore.selectedProvider : "azure");
    const data = yield call(getAzureActivityLogsApi, params, provider);
    yield put({ type: GET_AZURE_ACTIVITY_LOGS_SUCCESS, data });
  } catch (error) {
    yield put({ type: GET_AZURE_ACTIVITY_LOGS_ERROR, error });
  }
}

/**
 * Get Login Saga
 */
export function* manageAzureActivityLogsSaga() {
  yield takeLatest(GET_AZURE_ACTIVITY_LOGS, getAzureActivityLogsList);
}
